import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import NumericInput from "react-numeric-input";

const AreaSettingsLightIntensity = forwardRef((props, ref) => {
  let jwt = localStorage.getItem("JWT");
  let link = localStorage.getItem("link");

  let data = props.data;
  let settingsType = props.type;
  const { t } = useTranslation();
  const [lightValue, setLightValue] = useState(null);
  const [originalValue, setOriginalValue] = useState(null);
  const [saving, setSaving] = useState(false);

  const isDirty = () => lightValue !== originalValue;
  const save = async () => {
    if (!isDirty() || saving) return;

    setSaving(true);
    try {
      await axios.put(
        link +
          "/api/" +
          settingsType +
          "/LightIntensity?newIntensity=" +
          lightValue,
        data.ids,
        {
          headers: {
            Authorization: "Bearer " + jwt,
          },
        },
      );

      setOriginalValue(lightValue);
      if (typeof props.onSaved === "function") {
        props.onSaved(lightValue);
      }
    } finally {
      setSaving(false);
    }
  };

  const reset = () => {
    setLightValue(originalValue);
  };

  useEffect(() => {
    let value = null;
    if (data?.lightIntensity_Current !== undefined) {
      value = data.lightIntensity_Current;
    } else if (data?.lightIntensity !== undefined) {
      value = data.lightIntensity;
    }

    setLightValue(value);
    setOriginalValue(value);
  }, [props.data]);

  useImperativeHandle(
    ref,
    () => ({
      save,
      reset,
      isDirty,
    }),
    [originalValue, lightValue],
  );
  return (
    <div className="settings-groups">
      <div className="settings-name">{t("allgemein.helligkeit")} %</div>
      <NumericInput
        className="input-numeric input100"
        mobile="auto"
        value={lightValue}
        min={0}
        max={100}
        onChange={setLightValue}
      />
    </div>
  );
});

export default AreaSettingsLightIntensity;
